module.exports = __webpack_public_path__ + "img/home_en.90fb79d.jpg";